import { getHomologationLogoUrl } from '@wyz/utils';
import * as React from 'react';
import { Img } from '../../index';
import './style.scss';

type Props = {
  brand: string;
  imageBaseUrl: string;
  fallback?: React.ReactNode;
  ean?: string;
  maxHeight?: number;
};

const HomologationLogo = ({
  brand,
  imageBaseUrl,
  fallback = null,
  ean,
  maxHeight = 20,
}: Props) => (
  <Img
    src={getHomologationLogoUrl(brand)}
    baseUrl={imageBaseUrl}
    alt={brand}
    className='homologation-logo'
    style={{ maxHeight }}
    defaultImage=''
    errorFallback={fallback}
    data-cy={ean ? `product-info-homologation-logo-${ean}` : undefined}
  />
);

export default HomologationLogo;
